import { render } from "./favouriteProduct.vue?vue&type=template&id=17f19816&scoped=true"
import script from "./favouriteProduct.vue?vue&type=script&lang=js"
export * from "./favouriteProduct.vue?vue&type=script&lang=js"

import "./favouriteProduct.vue?vue&type=style&index=0&id=17f19816&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f19816"]])

export default __exports__